import axios from "axios";
import Vue from "vue";
import CONSTANTS from "@/constants";

const { CROP_MODAL_STEP } = CONSTANTS.MODAL_STEPS;

const uploadLogos = {
  namespaced: true,

  state: () => ({
    loadingState: false,

    //Normalized and uploaded logos
    uploadedLogos: [],
    totalOfLogosToBeUploaded: 0,

    //The logo displayed in the UploadLogoModal
    showUploadLogosModal: false,
    editableLogo: {},
    modalStep: CROP_MODAL_STEP,

    // Apply on the whole project,or just the active product
    applyMode: "project",

    //'upload' -> new logo
    //'edit' -> edit logo
    logoModalAction: "upload",
  }),

  getters: {
    logoFileData: (state) => {
      const file = state.editableLogo.file;

      if (file) {
        let fileName = file?.name;

        let fileExtension = fileName?.substring(fileName?.lastIndexOf(".") + 1);

        let fSExt = new Array("Bytes", "KB", "MB", "GB"),
          i = 0,
          _size = file?.size;
        while (_size > 900) {
          _size /= 1024;
          i++;
        }

        let fileSize = Math.round(_size * 100) / 100 + " " + fSExt[i];

        return {
          fileName,
          fileExtension,
          fileSize,
        };
      } else {
        return {};
      }
    },

    normalizeLogoData:
      () =>
      ({
        id,
        original_logo_id,
        url,
        zoom,
        position,
        content,
        type,
        types,
        asset_id,
        assetId,
        filename,
      }) => {
        return {
          id: id,
          originalLogoId: original_logo_id,
          url: url?.startsWith("https") ? url : CONSTANTS.S3_BASE_URL + url,
          zoom: zoom || CONSTANTS.DEFAULT_SCREEN_LOGO_PROPERTIES.zoom,
          position:
            position || CONSTANTS.DEFAULT_SCREEN_LOGO_PROPERTIES.position,
          content,
          type: type || types || [],
          asset_id: asset_id || assetId,
          filename: filename,
        };
      },

      editableLogo: (state) => {
        return state.editableLogo
      }
  },

  actions: {
    async uploadLogos(
      { rootState, state, getters, dispatch, commit },
      { logosToBeUploaded, applyMode, uploadToThreekit }
    ) {
      console.time("test");

      //applyMode -> to apply on the whole project,or just the active product
      dispatch("setLoadingState", true);
      dispatch("showroom/setCustomizationBoxLoading", true, { root: true });
      commit("setTotalOfLogosToBeUploaded", logosToBeUploaded.length);
      commit("setShowEditLogoModalState", true);
      commit("APPLY_MODE", applyMode || state.applyMode);

      const logoToBeUploaded = logosToBeUploaded[0];
      const size = logoToBeUploaded?.size / 1024 / 1024;
      if (size > 5) throw new Error("Logo max size exceeded");

      let formData = new FormData();
      let normalizedLogo = {};
      let base64URL = "";
      formData.append("file", logoToBeUploaded);
      formData.append("file_name", logoToBeUploaded.name);

      try {
        let assetId = "";

        console.log({ logoToBeUploaded });
        const fileName = logoToBeUploaded.name;
        const getExtensionRegex = new RegExp("[^.]+$");
        const extension = fileName.match(getExtensionRegex);
        console.log({ fileName, extension });
        const isCommonImage = ["jpg", "svg", "png"].includes(extension[0]);

        //For Svg, png or jpg Base64
        if (isCommonImage) {
          base64URL = await dispatch("encodeFileAsBase64URL", logoToBeUploaded);
          formData.append("image_data", base64URL);

          if (uploadToThreekit) {
            assetId = await dispatch("uploadLogoToThreekit", {
              logoToBeUploaded,
            });
            formData.append("asset_id", assetId);
          }
        }

        const urlForCommonImages =
          rootState.settings.endpoint + "api/logos/base64";
        const urlForNonCommonImages = rootState.settings.endpoint + "api/logos";
        const url = isCommonImage ? urlForCommonImages : urlForNonCommonImages;

        const response = await axios.post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + rootState.auth.apiToken,
          },
        });

        //Merge the response logo, and the original File, so in the UploadModal we can calculate the fileSize, fileName, etc
        //(see logoFileData Getter)
        const logoData = response.data;
        const logo = { ...logoData, file: logoToBeUploaded };

        if (isCommonImage) {
          logo["content"] = base64URL;
          logo["assetId"] = assetId;
        }

        normalizedLogo = {
          ...getters.normalizeLogoData(logo),
        };

        //Only run this for the first uploaded logo
        console.log('commit("setEditableLogo", normalizedLogo);', normalizedLogo)
        commit("setEditableLogo", normalizedLogo);
        dispatch("setLoadingState", false);
        dispatch("showroom/setCustomizationBoxLoading", false, {
          root: true,
        });
      } catch (e) {
        console.log(e);
        dispatch("setLoadingState", false);

        commit("setShowEditLogoModalState", false);
        dispatch(
          "showToast",
          {
            txt: e,
            type: "error",
          },
          { root: true }
        );
      }
    },

    async uploadLogoToThreekit(_, { logoToBeUploaded }) {
      const assetId = await window.decorationsApi.uploadImage(logoToBeUploaded);
      console.log({ assetId });
      return assetId;
    },

    async getThreekitAsset(_, assetId) {
      try {
        console.log("getThreekitAsset assetId ", assetId);
        const asset = await axios.get(
          `${process.env.VUE_APP_THREEKIT_ENDPOINT}/api/assets/${assetId}?orgId=${process.env.VUE_APP_THREEKIT_ORG_ID}&bearer_token=${process.env.VUE_APP_THREEKIT_TOKEN}`
        );
        console.log({ asset });
        return asset?.data;
      } catch (error) {
        console.log(error);
        throw Error(error);
      }
    },

    async getThreekitLogoBase64({ dispatch }, assetId) {
      return new Promise((resolve, reject) => {
        //Get Threekit Asset
        dispatch("getThreekitAsset", assetId)
          .then((asset) => {
            console.log({ asset });
            console.log("getThreekitLogoBase64 ASSET ", asset);
            const fileId = asset?.importedFileId;
            //Get Threekit Content
            return fetch(
              `${process.env.VUE_APP_THREEKIT_ENDPOINT}/api/files/${fileId}/content?bearer_token=${process.env.VUE_APP_THREEKIT_TOKEN}`
            );
          })
          .then((res) => {
            console.log({ res });
            return res?.blob();
          })
          .then((blob) => {
            let base64String = "";
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = function () {
              base64String = reader.result;
              console.log({ base64String });
              return resolve(base64String);
            };
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },

    async encodeFileAsBase64URL(_, file) {
      console.log(file);
      return (
        file &&
        new Promise((resolve) => {
          const reader = new FileReader();
          reader.addEventListener("loadend", () => {
            resolve(reader.result);
          });
          reader.readAsDataURL(file);
        })
      );
    },

    goToNextLogo({ state, commit }) {
      //In UploadLogoModal. Go to the next logo, but first delete the previous logo
      commit("setModalStep", CROP_MODAL_STEP);
      commit("clearPreviousLogoBeingEdited");
      commit("setEditableLogo", state.uploadedLogos[0]);
    },

    openEditLogoModal({ commit }) {
      commit("setShowEditLogoModalState", true);
    },

    hideEditLogoModal({ commit }) {
      commit("setShowEditLogoModalState", false);
    },

    setEditableLogo({ commit }, logo) {
      commit("setEditableLogo", logo);
    },

    openEditLogoModalToEditSingleLogo({ commit }, logoData) {
      if (logoData) {
        commit("setEditableLogo", logoData);
        commit("setUploadedLogo", logoData);
      }
      commit("setShowEditLogoModalState", true);
      commit("SET_ACTION", "edit");
    },

    closeEditLogoModal({ commit }) {
      commit("clearUploadedLogos", {});
      commit("setEditableLogo", {});
      commit("setShowEditLogoModalState", false);
      commit("SET_ACTION", "upload");
    },

    setLoadingState({ commit }, loadingState) {
      commit("SET_LOADING_STATE", loadingState);
    },

    setApplyMode({ commit }, applyMode) {
      commit("APPLY_MODE", applyMode);
    },

    setAction({ commit }, action) {
      commit("SET_ACTION", action);
    },

    clearLogos({ commit }) {
      commit("CLEAR_LOGOS");
    },
  },

  mutations: {
    setUploadedLogo(state, logo) {
      state.uploadedLogos = [...state.uploadedLogos, logo];
    },

    clearUploadedLogos(state) {
      state.uploadedLogos = [];
    },

    setTotalOfLogosToBeUploaded(state, number) {
      state.totalOfLogosToBeUploaded = number;
    },

    setEditableLogo(state, logo) {
      Vue.set(state, "editableLogo", logo);
      // state.editableLogo = logo
    },

    clearPreviousLogoBeingEdited(state) {
      const newArray = [...state.uploadedLogos];
      newArray.shift();
      state.uploadedLogos = newArray;
    },

    SET_LOADING_STATE(state, booleanState) {
      state.loadingState = booleanState;
    },

    setShowEditLogoModalState(state, booleanState) {
      state.showUploadLogosModal = booleanState;
    },

    setModalStep(state, step) {
      state.modalStep = step;
    },

    APPLY_MODE(state, applyMode) {
      state.applyMode = applyMode;
    },

    SET_ACTION(state, action) {
      state.logoModalAction = action;
    },

    CLEAR_LOGOS(state) {
      state.uploadedLogos = [];
    },
  },
};

export default uploadLogos;
